import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import transitionController from '../transitionController';

/**
 * Wraps the React Router Link component. Navigation happens when the
 * transition curtain finishes covering the screen (animation COMPLETE),
 * instead of after a fixed timer.
 */
export default class DelayLink extends React.Component {
    static propTypes = {
        onDelayStart: PropTypes.func,
        onDelayEnd: PropTypes.func
    };

    static defaultProps = {
        onDelayStart: () => {
        },
        onDelayEnd: () => {
        }
    };

    static contextTypes = Link.contextTypes;

    /**
     * Called when the link is clicked
     *
     * @param {Event} e
     */
    handleClick = (e) => {

        const {replace, to, onDelayStart, onDelayEnd} = this.props;
        const {history} = this.context.router;
        onDelayStart(e, to);
        if (e.defaultPrevented) {
            return;
        }
        if (to === replace) {
            return;
        }

        e.preventDefault();

        transitionController.cover().then(() => {
            if (replace) {
                history.replace(to);
            } else {
                history.push(to);
            }
            onDelayEnd(e, to);
        });
    };

    render() {
        const props = Object.assign({}, this.props);
        delete props.onDelayStart;
        delete props.onDelayEnd;
        return (

            <Link {...props} onClick={this.handleClick}/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DelayLink.js